import React from "react";

import { FormHelperText } from "@mui/material";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { MdCheck } from "react-icons/md";

import useStyles, { DivWithBackground } from "./styles";

export const OPTIONS_COLORS = [
  "#F97066",
  "#F670C7",
  "#FDB022",
  "#32D583",
  "#717BBC",
  "#36BFFA",
  "#101323",
];

const BORDER_COLORS: { [x: string]: string } = {
  "#F97066": "#FECDCA",
  "#F670C7": "#FCCEEE",
  "#FDB022": "#FEDF89",
  "#32D583": "#A6F4C5",
  "#717BBC": "#C8CCE5",
  "#36BFFA": "#B9E6FE",
  "#101323": "#344054",
};

type ListColorProps = {
  viewOnly?: boolean;
  error?: boolean;
  errorMessage?: string;
  colorSelected?: string;
  onChangeColor?: (color: string) => void;
};

export const ListColor = ({
  error,
  errorMessage,
  colorSelected,
  onChangeColor,
  viewOnly,
}: ListColorProps) => {
  const classes = useStyles({});

  return (
    <>
      <div className={classes.sectionColor} data-cy="list-color-section">
        {OPTIONS_COLORS.map((color, index) => {
          return (
            <DivWithBackground
              key={color}
              color={color}
              colorSelected={colorSelected}
              borderColor={color === colorSelected ? BORDER_COLORS[color] : ""}
              onClick={() => {
                if (onChangeColor && !viewOnly) onChangeColor(color);
              }}
              data-cy={`list-color-value-${index}`}
            >
              {color === colorSelected && (
                <MdCheck
                  color={color === OPTIONS_COLORS[OPTIONS_COLORS.length - 1] ? "#fff" : "#1C1C1C"}
                />
              )}
            </DivWithBackground>
          );
        })}
      </div>

      {error && errorMessage && (
        <FormHelperText className={classes.formHelper} data-cy="list-color-errors">
          <InfoOutlinedIcon htmlColor="#D92D20" className={classes.iconError} />
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
};
